
import { ValidationObserver } from 'vee-validate';
import TextFieldWithValidation from '../components/inputs/TextFieldWithValidation';
import { mapState } from 'vuex';
export default {
  components: {
    TextFieldWithValidation,
    ValidationObserver,
  },
  layout: 'authentication',
  data() {
    return {
      error: '',
      loginData: {
        email: '',
        password: '',
      },
      redirecting: false,
    };
  },
  computed: {
    ...mapState('user', ['user', 'loggingIn']),
  },
  mounted() {
    if (this.$route.query.redirect) {
      if (this.user) {
        this.redirecting = true;
        window.location.href = `${this.$route.query.redirect}?auth_token=${this.user.readme_token}`;
      }
    }
  },
  methods: {
    async login() {
      try {
        this.error = '';
        this.redirecting = Boolean(this.$route.query.redirect);
        const userData = await this.$store.dispatch('user/login', {
          email: this.loginData.email.toLowerCase(),
          password: this.loginData.password,
        });
        if (this.$route.query.redirect) {
          this.redirecting = true;
          window.location.href = `${this.$route.query.redirect}?auth_token=${userData.readme_token}`;
        } else {
          await this.$router.push({
            path: '/',
          });
        }
      } catch (err) {
        switch (err.name) {
          case 'NotAuthorizedException':
            this.error = 'Incorrect username or password.';
            break;
          case 'UserNotConfirmedException':
            this.error =
              'This user is not confirmed. Check your email for confirmation.';
            break;
          default:
            this.error = 'Something went wrong. Try again in a few minutes.';
        }
      }
    },
  },
};
